import { Component, Inject, Input, Output, EventEmitter } from 'ng-metadata/core';


@Component({
    selector: 'prm-library',
    templateUrl: 'components/search/fullView/getit/opac/library/library.html',
})

export class PrmLibrary {

    @Input() public lib;
    @Output() private clickEvent= new EventEmitter<void>();

    constructor(@Inject('$translate')  private $translate:ng.translate.ITranslateService){
        
    }

    public onClick(){
		 this.clickEvent.emit(null);
	}

    private getLocationName(){
		if (this.lib.indexOf(":")>-1 && this.lib.indexOf(":")<this.lib.length-1)
			return this.lib.split(":",2)[1];
		else
			return this.$translate.instant(this.lib);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/library/library.directive.ts